import axiosInstance from '../../Config/axiosConfig';

export const getLikesMe = async () => {
  try {
    const response = await axiosInstance.get('/user/likes-me');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getMyLikes = async () => {
  try {
    const response = await axiosInstance.get('/user/my-likes');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getViewedMe = async () => {
  try {
    const response = await axiosInstance.get('/user/viewed-me');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getFavoritedMe = async () => {
  try {
    const response = await axiosInstance.get('/user/favorites/of-me');
    // Return the data array directly if it exists, otherwise return the whole response
    return response.data?.data || response.data || [];
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getMyFavorites = async () => {
  try {
    const response = await axiosInstance.get('/user/favorites');
    // Return the data array directly if it exists, otherwise return the whole response
    return response.data?.data || response.data || [];
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

